import { Controller } from '@hotwired/stimulus';
import toastr from 'toastr';

export default class extends Controller {
  connect() {
    const { messageType, message } = this.element.dataset;
    toastr[messageType === 'success' ? 'success' : 'error'](message);
  }
}
